import { Palette } from "lucide-solid";
import { createSignal } from "solid-js";

import { Button } from "@/components/ui/Button";
import { FormDialog } from "@/components/ui/FormDialog";
import { t } from "@/lib/i18n";

import { AppearancePanel } from "./AppearancePanel";

export function AppearanceButton() {
  const [open, setOpen] = createSignal(false);

  return (
    <>
      <button
        type="button"
        data-testid="appearance-open"
        aria-label={t("appearance.title")}
        title={t("appearance.title")}
        class="inline-flex h-9 items-center gap-1.5 rounded-[10px] border border-[var(--header-border)] bg-[var(--bg-surface)] px-2.5 text-[13px] font-semibold text-[var(--fg-strong)] shadow-[0_1px_2px_rgba(11,18,32,0.04)] transition hover:border-[var(--border-strong)]"
        onClick={() => setOpen(true)}
      >
        <Palette size={16} stroke-width={1.75} />
        <span class="hidden md:inline">{t("appearance.open")}</span>
      </button>
      <FormDialog
        open={open()}
        title={t("appearance.title")}
        onClose={() => setOpen(false)}
        maxWidth="max-w-2xl"
        footer={
          <Button variant="secondary" onClick={() => setOpen(false)}>
            {t("common.cancel")}
          </Button>
        }
      >
        <AppearancePanel heading={false} />
      </FormDialog>
    </>
  );
}
